import { render, staticRenderFns } from "./StrengthRow.vue?vue&type=template&id=5fe631e1&scoped=true&"
import script from "./StrengthRow.vue?vue&type=script&lang=js&"
export * from "./StrengthRow.vue?vue&type=script&lang=js&"
import style0 from "./StrengthRow.vue?vue&type=style&index=0&id=5fe631e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe631e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
